import { render, staticRenderFns } from "./AdvertiseList.vue?vue&type=template&id=babc002e"
import script from "./AdvertiseList.vue?vue&type=script&lang=js"
export * from "./AdvertiseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports